import { useContext, Context } from 'react';
import _noop from 'lodash/noop';

export const emptyLogDataContext = {
    logs: [] as LogEvent[],
    addHandler: _noop,
    deleteHandlers: _noop,
};

export const useLogDataBase = (
    logEventsContext: Context<LogDataProviderValue>,
): LogDataProviderValue => {
    if (logEventsContext === null || logEventsContext === undefined) {
        return emptyLogDataContext;
    }

    return useContext(logEventsContext);
};
